<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/en22-1.jpg"
              width="100%"
              alt="Blueshark R1 positioning system"
            />
          </div>
          <div class="text fs_middle fw_bold t22">
            Positioning System
            <div class="fs_tiny color_gray t22_1">
              바이크를 쉽게 찾는 위치 추적시스템
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/sk/p22-2.jpg"
              width="100%"
              alt="Blueshark R1 virtual vroom"
            />
          </div>
          <div class="text fs_middle fw_bold t22">
            Virtual <span class="fs_middle fw_bold color_theme">Vroom</span>
            <div class="fs_tiny color_gray t22_1">가상 엔진 소리 기능</div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t22 {
  top: 4vw;
  text-align: center;
  width: 100%;
}
.t22_1 {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper_sk/swiper22.vue